import { render, staticRenderFns } from "./home-type2.vue?vue&type=template&id=8a19ee58&scoped=true"
import script from "./home-type2.vue?vue&type=script&lang=js"
export * from "./home-type2.vue?vue&type=script&lang=js"
import style0 from "./home-type2.vue?vue&type=style&index=0&id=8a19ee58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a19ee58",
  null
  
)

export default component.exports